import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Checkbox, Column, Row, Typography } from 'seagull';
export const ProposalItemCheckbox = (param)=>{
    let { item, checked, disabled, onChange, testId, className } = param;
    var _item_badges;
    return /*#__PURE__*/ _jsx(Checkbox, {
        checked: checked,
        disabled: disabled,
        onChange: onChange,
        testId: testId,
        className: className,
        bi: {
            name: 'agent_drafting_proposal_item'
        },
        children: /*#__PURE__*/ _jsxs(Column, {
            gap: 2,
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    gap: 6,
                    alignItems: "center",
                    wrap: true,
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph2",
                            skin: "secondary",
                            children: item.name
                        }),
                        (_item_badges = item.badges) === null || _item_badges === void 0 ? void 0 : _item_badges.map((badge, idx)=>/*#__PURE__*/ _jsx(Badge, {
                                rounded: true,
                                outlined: true,
                                children: badge
                            }, idx))
                    ]
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    weight: "normal",
                    children: item.detail
                })
            ]
        })
    });
};
